import React from "react";
import {EmailSignup} from "../EmailSignup";

export const FoundersSection = () => {

  return <div className={'AppSection WhiteSection'}>
    <div className={'AppSectionContent FoundersSection'}>

      <div className={'FoundersSectionLeft'}>
        <div/>
        {/* placeholder, the background image is used so it can scale*/}
      </div>

      <div className={'PlainTextBox'}>
        <h2 className={'OrangeText'}>From our healing journeys to yours.</h2>
        <div className={'IntroCalloutText'}>
          After facing our own health challenges, ranging from infertility and miscarriage to chronic back
          pain and eczema, we saw the limitations of conventional care. We found healing through Eastern and
          Western holistic care, but the process of getting there was not easy. We built Kensu as a
          resource for people like us, who deserve quality care that lets you be your healthiest self for
          years to come.
        </div>
        <div style={{marginTop: 25, flex: 1, display: 'flex', alignItems: 'end', justifyContent: 'center'}}>
          <div style={{width: '90%'}}>
            <EmailSignup isAlwaysStacked={true}/>
          </div>
        </div>
      </div>
    </div>
  </div>
}